import * as React from "react";
const SvgFiRrVacuumRobot = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-vacuum-robot_svg__a)">
      <path
        fill="#062147"
        d="M23.707 1.707A.999.999 0 1 0 22.293.293l-2.552 2.552A11.94 11.94 0 0 0 12.001 0C9.05 0 6.35 1.074 4.258 2.845L1.707.293A.999.999 0 1 0 .293 1.707L2.845 4.26A11.94 11.94 0 0 0 0 12c0 6.617 5.383 12 12 12s12-5.383 12-12c0-2.949-1.074-5.649-2.845-7.74zM15 2.461v3.564A4.95 4.95 0 0 0 12 5c-1.13 0-2.162.391-3 1.026V2.461a9.986 9.986 0 0 1 6 0m0 7.54c0 1.653-1.346 3-3 3s-3-1.347-3-3c0-1.655 1.346-3 3-3s3 1.345 3 3m-3 12C6.486 22 2 17.513 2 12c0-3.693 2.016-6.916 5-8.648V10c0 2.757 2.243 5 5 5s5-2.243 5-5V3.353c2.984 1.732 5 4.955 5 8.647 0 5.514-4.486 10-10 10"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-vacuum-robot_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrVacuumRobot;
